export enum OriginDqeEnum {
    INTERVENTION_ADDRESS = "INTERVENTION_ADDRESS",
    MY_ACCOUNT_ADDRESS = "MY_ACCOUNT_ADDRESS",
    ORDER_ADDRESS = "ORDER_ADDRESS"
}
